import { rootApi } from "../../api/rootApi";

export const tdsCertificateApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        uploadTdsCertificate: builder.mutation({
            query: ({ token, tenant_id, body }) => ({
                url: `/tenant/tds-certificates/`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    slug: tenant_id,
                },
                body,
            }),
            invalidatesTags: ["TdsCertificates"],
        }),
        getTdsCertificates: builder.query({
            query: ({ token, tenant_id, ...params }) => {
                const searchParams = new URLSearchParams(params);
                return {
                    url: `/tenant/tds-certificates/?${searchParams.toString()}`,
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                        slug: tenant_id,
                    },
                };
            },
            providesTags: ["TdsCertificates"],
        }),
        updateTdsCertificate: builder.mutation({
            query: ({ token, tenant_id, id, body }) => ({
                url: `/tenant/tds-certificates/${id}`,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    slug: tenant_id,
                },
                body,
            }),
            invalidatesTags: ["TdsCertificates"],
        }),
        deleteTdsCertificate: builder.mutation({
            query: ({ token, tenant_id, id }) => ({
                url: `/tenant/tds-certificates/${id}`,
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    slug: tenant_id,
                },
            }),
            invalidatesTags: ["TdsCertificates"],
        }),
    }),
});

export const {
    useUploadTdsCertificateMutation,
    useGetTdsCertificatesQuery,
    useUpdateTdsCertificateMutation,
    useDeleteTdsCertificateMutation,
} = tdsCertificateApi;
